export default __webpack_public_path__ + "01f0f79864a063a720a7409390bbeb29.png";